import { useEffect, useState } from "react"
import Modal from "../../components/Modal"
import { useAssetDetailExtensionV2 } from "../../hooks/useAssetDetailExtensionV2"
import SimpleBackdropLoader from "../BackdropLoading/BackdropLoading"
import AssetDetailDataTable from "./AssetDetailDataTable"
import DynamicDetailFormModal from "./DynamicDetailFormModal"
import CompareAssessmentModal from "./CompareAssessmentModal"
import CompareIcon from "@mui/icons-material/Compare"
import { useLocalization } from "../../providers/LocalizationProvider"

const FormHistoryModal = ({ open, onClose, formItem }) => {
    const submissionId = formItem?.submission?.id
    const [selectedForm, setSelectedForm] = useState(null)
    const [openViewModal, setOpenViewModal] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const [openCompareModal, setOpenCompareModal] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0)
    const { voiceiiTags } = useLocalization()

    // Buttons for datatable
    const tableButtons = [
        {
            text: `${voiceiiTags("Compare Selected")} (${selectedRows.length})`,
            icon: <CompareIcon />,
            action: () => setOpenCompareModal(true),
            disabled: selectedRows.length < 2,
        },
    ]

    const { data, isLoading, refetch } = useAssetDetailExtensionV2("get_form_revisions", {
        enabled: open && !!submissionId,
        extraParams: {
            entity_id: submissionId,
        },
    })

    const tableData = data?.data?.asset_detail_details || []
    const meta = data?.meta || {}

    useEffect(() => {
        if (open && submissionId) {
            refetch()
        }
    }, [refreshKey])

    return (
        <Modal fullWidth maxWidth="lg" status={open} disableSave onClose={onClose}>
            <SimpleBackdropLoader showLoader={isLoading} />

            <AssetDetailDataTable
                isMultiSelect={true}
                onSelectedRowsChange={(rows) => {
                    setSelectedRows(rows)
                }}
                rawData={tableData}
                meta={meta}
                isLoading={isLoading}
                datatableTitle={`${formItem?.title_key} — ${voiceiiTags("History")}`}
                columnConfigKey="patient_form_history_columns_config"
                refetch={refetch}
                dataTableHeight={500}
                buttons={tableButtons}
                addActionName={voiceiiTags("New Entry")}
                addAction={() => {
                    setOpenViewModal(true)
                    setSelectedForm({
                        schema: formItem?.schema,
                        title_key: formItem?.title_key,
                        slug: formItem?.slug,
                        mode: "add",
                    })
                }}
                actions={[
                    {
                        name: voiceiiTags("View"),
                        type: "view",
                        buttonType: "icon",
                        slug: "view",
                    },
                ]}
                onActionClick={(event, { type, data, action_property }) => {
                    if (type === "view") {
                        setOpenViewModal(true)
                        setSelectedForm({
                            submission: { data: data?.values?.data },
                            schema: formItem?.schema,
                            title_key: voiceiiTags("Viewing Entry"),
                            mode: "view", // ← NEW: View Mode
                        })
                    }
                }}
            />
            <DynamicDetailFormModal
                open={openViewModal}
                onClose={() => setOpenViewModal(false)}
                formItem={selectedForm}
                setRefreshKey={setRefreshKey}
            />
            <CompareAssessmentModal
                open={openCompareModal}
                onClose={() => setOpenCompareModal(false)}
                selectedRows={selectedRows}
                schema={formItem?.schema}
                formTitle={formItem?.title_key}
                patientName={formItem?.patient_name}
            />
        </Modal>
    )
}
export default FormHistoryModal
